import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ShopTitle() {
  return <section data-section-id="223499" id="shop-title" className="bg-background text-foreground py-16 md:py-24 px-4 md:px-8 border-b border-border">
      <div className="max-w-7xl mx-auto text-center flex flex-col items-center">
        <h1 className="font-default text-4xl md:text-5xl lg:text-7xl font-normal tracking-tight mb-6 text-foreground">
          M / O Wellness Edit
        </h1>
        <p className="font-default text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto mb-8 leading-relaxed">
          Curated essentials for your protocol. Discover our premium selection of medical-grade supplements, recovery tools, and luxury self-care products.
        </p>
        <Button asChild size="lg" className="font-default bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 rounded-md transition-opacity">
          <Link to="#">Shop All Products</Link>
        </Button>
      </div>
    </section>;
}